import React, { useState } from 'react';
import classnames from 'classnames';
import * as mobxReact from 'mobx-react';
import { IAttendeeOrganizationDTO } from '../../../../../../../api/attendees.dao';
import ChevronSVG from '../../../../../../../images/svg/icons8-expand-arrow';
import { IConnectionAttendeeDTO, IConnectionOrganizationDTO } from '../../../../../../../api/connections.dao';
import classNames from 'classnames';
import Text from '../../../../../../global/text/text';

import './organization.scss';

export interface IOrganizationProps extends IAttendeeOrganizationDTO {
    organization: IConnectionOrganizationDTO;
    removeOrganization?: (organizationId: number) => void;
    removeAttendee?: (attendeeId) => void;
}

export interface IPropsAttendee {
    attendee: IConnectionAttendeeDTO;
    removeAttendee?: (attendeeId) => void;
}

const Attendee = mobxReact.observer((props: IPropsAttendee) => {
    const { attendee, removeAttendee } = props;
    return (
        <div key={attendee.attendeeId} className='organization__row'>
            <Text
                tag='div'
                className={classNames({'organization__attendee-with-remove-btn': removeAttendee})}
                message={`${attendee.firstName} ${attendee.lastName}`}
                withEllipsis
            />
            {removeAttendee &&
                <Text
                    tag='label'
                    onClick={() => removeAttendee(attendee.attendeeId)}
                    className='organization__remove-label'
                    id='oe.common.remove'
                    description='Button label'
                    message='Remove'
                />
            }
        </div>
    );
});

const Organization = (props: IOrganizationProps) => {
    const [isOpen, setIsOpen] = useState(true);
    const {
        name,
        organizationId,
        removeAttendee,
        removeOrganization,
    } = props;

    const attendees = props.attendees || [];

    const handleRemoveOrganization = () => {
        removeOrganization(organizationId);
    };

    const handleOpenOrganization = () => {
        if (attendees.length) setIsOpen(!isOpen);
    };

    return (
        <div>
            <div className='organization__header'>
                <div
                    className={classnames(
                        'organization__header-name',
                        {
                            'organization__header-name--active': isOpen,
                        }
                    )}
                    onClick={handleOpenOrganization}
                >
                    <Text
                        tag='label'
                        message={name}
                        withEllipsis
                        className={classNames({'organization__org-with-remove-btn': removeOrganization})}
                    />
                    {attendees.length ? (
                        <div className='organization__header-icon'>
                            <ChevronSVG />
                        </div>
                    ) : null}
                </div>

                {removeOrganization && (
                    <Text
                        tag='label'
                        onClick={handleRemoveOrganization}
                        className='organization__remove-label'
                        id='oe.common.remove'
                        description='Button label'
                        message='Remove'
                    />
                )}
            </div>
            {
                isOpen &&
                    attendees
                        .slice()
                        .sort((a, b) => a.lastName.localeCompare(b.lastName))
                        .map(a => (
                            <Attendee
                                attendee={a}
                                key={a.attendeeId}
                                removeAttendee={removeAttendee} />
                        ))}
        </div>
    );
};

export { Organization, Attendee };
